import { useState, useEffect, useRef, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import styles from './AdminPrintFlat.module.css'

// ------ Services ------ //
import * as badgeManagementService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'
import * as badgeService from '../../../services/badgeManagementService'
import * as kioskService from '../../../services/kioskService'
import * as eventManagementService from '../../../services/eventManagementService'
// ------ Components ------ //
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import Organization from '../../../components/Badging/AdminPrint/Organization'
import PaidAfterDate from '../../../components/Badging/AdminPrint/PaidAfterDate'
import RegistrantName from '../../../components/Badging/AdminPrint/RegistrantName'
import RegistrationId from '../../../components/Badging/AdminPrint/RegistrationId'
import RegistrationType from '../../../components/Badging/AdminPrint/RegistrationType'
import NewRegistration from '../../../components/Badging/AdminPrint/NewRegistration'
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"

const AdminPrintFlat = () => {
    // State
    const [adminPrintChoicesList, setAdminPrintChoicesList] = useState([])
    const [clientEventInfo, setClientEventInfo] = useState({})
    const [showBusy, setShowBusy] = useState(false)

    const [selectedOption, setSelectedOption] = useState({})
    const [registrants, setRegistrants] = useState({})
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [regError, setRegError] = useState(null);
    const [templateSetting, setTemplateSetting] = useState(null);
    const [templateString, setTemplateString] = useState(null);
    const [htmlString, setHTMLString] = useState(null);
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const [loaded, setLoaded] = useState(false)
    const [formData, setFormData] = useState({
        clientId: clientEventInfo.clientId,
        eventId: clientEventInfo.eventId,
        printChoice: null,//dropdown selection to use custom or thirdparty.
        recordPrint: false,
        paidAfterDate: null,
        newRegistration: null,
    })

    // useCallback
    const clearFormData = useCallback(
        () => {
            setFormData({
                clientId: clientEventInfo.clientId,
                eventId: clientEventInfo.eventId,
                printChoice: null,
                recordPrint: false,
                paidAfterDate: null,
                newRegistration: null,
            })
        },
        []
    )
    // Constants
    const location = useLocation()
    const passedState = location.state
    const clientEventInfoRef = useRef(null);

    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }
    }

    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    useEffect(() => {
        const fetchClientEventInfo = () => {
            // store into local object
            if (!passedState || !passedState.clientName) {
                //let localclientevent = clientEventService.getClientEvent()
                if (clientEventInfoRef.current) {
                    setClientEventInfo(clientEventInfoRef.current)
                }
            }
            else {
                let passedData = {
                    clientName: passedState.clientName,
                    clientId: passedState.clientId,
                    eventName: passedState.eventName,
                    eventId: passedState.eventId,
                }
                setClientEventInfo(passedData)
                clientEventInfoRef.current = passedData;
            }
        }

        const fetchAdminPrintChoices = async () => {
            const adminprintChoices = await badgeManagementService.getAdminPrintFlatSelections()
            adminprintChoices.map(choice => {
                // fix display for human eyes
                switch (choice.name) {
                    case 'EntireEvent':
                        choice.text = 'Entire Event'
                        choice.title = 'All registrants in event'
                        return choice
                    case 'RegistrantSearch':
                        choice.text = 'Registrant Search'
                        choice.title = 'Search registrants by first/last name, in event'
                        return choice
                    case 'RegistrationId':
                        choice.text = 'Registration Id'
                        choice.title = 'Search registrants by id, in event'
                        return choice
                    //case 'RegistrationType':
                    //    choice.text = 'Registration Type'
                    //    choice.title = 'Search registrants by registration type, in event'
                    //    return choice
                    //case 'PaidAfterDate':
                    //    choice.text = 'Paid After Date'
                    //    choice.title = 'Search registrants by paid after date, in event'
                    //    return choice
                    //case 'Organization':
                    //    choice.text = 'Organization'
                    //    choice.title = 'Search registrants by organization name, in event'
                    //    return choice
                    case 'PrintFranky':
                        choice.text = 'Print Franky'
                        choice.title = 'Combination of multiple features ("longest org", "longest first", etc.)'
                        return choice
                    case 'NewRegistration':
                        choice.text = 'New Registration'
                        choice.title = 'Add by email address before printing'
                        return choice
                    case 'PrintMissingBadges':
                        choice.text = 'Print Missing Badges'
                        choice.title = 'All registrants not yet printed, in event'
                        return choice
                    default:
                        return ''
                }
            });
            //console.log("adminprintChoices are: ", adminprintChoices)
            setAdminPrintChoicesList(adminprintChoices)
        }

        fetchClientEventInfo()
        fetchAdminPrintChoices()

    }, [])

    // 

    useEffect(() => {
        const fetchData = async () => {
            // get all registrants that match option
            setShowBusy(true);
            switch (formData.printChoice) {
                case 'RegistrantSearch':
                case 'Registrant Search':
                    // pull full registrant, previously it was only the "small" to save time
                    const itemString = await kioskService.getAttendeesWithGuestsSearchPaged(await createSingleSearchBody(selectedOption.LocalRegistrationId));
                    const item = JSON.parse(itemString)
                    if (item && item.length > 0) {
                        item[0].clientId = clientEventInfo.clientId;
                        item[0].eventId = clientEventInfo.eventId;
                        item[0].clientName = clientEventInfo.clientName;
                    }
                    //let regSearchTemp = [
                    //    item
                    //]
                    setRegistrants(item)
                    //setPrintLoaded(true)
                    break;
                case 'RegistrationId':
                case 'Registration Id':
                    const registrationIdItemsString = await kioskService.getAttendeesWithGuestsSearchPaged(await createFullReturnSearchBody(selectedOption.value));
                    const registrationIdItems = JSON.parse(registrationIdItemsString)
                    if (registrationIdItems && registrationIdItems.length > 0) {
                        registrationIdItems.clientId = clientEventInfo.clientId;
                        registrationIdItems.eventId = clientEventInfo.eventId;
                        registrationIdItems.clientName = clientEventInfo.clientName;
                        setRegistrants(registrationIdItems)
                    }
                    break;
                //case 'RegistrationType':
                //case 'Registration Type':
                //    const registrationTypeItemsString = await kioskService.getAttendeesWithGuestsByFieldSearch(await createFullReturnSearchBody(selectedOption.value));
                //    const registrationTypeItems = JSON.parse(registrationTypeItemsString)
                //    if (registrationTypeItems && registrationTypeItems.length > 0) {
                //        setRegistrants(registrationTypeItems)
                //    }
                //    break;                   
                //case 'Organization':
                //    const organizationItemsString = await kioskService.getAttendeesWithGuestsByFieldSearch(await createFullReturnSearchBody(selectedOption.value));
                //    const organizationItems = JSON.parse(organizationItemsString)
                //    if (organizationItems && organizationItems.length > 0) {
                //        setRegistrants(organizationItems)
                //    }
                //    break;
                default:
                    let defaultTemp = [
                        selectedOption
                    ]
                    setRegistrants(defaultTemp)
                    break;
            }
            setShowBusy(false);
        }
        if (selectedOption && selectedOption.value !== undefined) {
            fetchData();
        }

    }, [selectedOption])

    useEffect(() => {
        if (!clientEventInfo?.clientId || !clientEventInfo?.clientName) return;

        const fetchData = async () => {
            try {
                const req = await createRequestBody();
                const templateSettings = await badgeService.retrieveFlatTemplate(req);
                if (templateSettings) {
                    setTemplateSetting(templateSettings);
                    setTemplateString(templateSettings.templateString)
                }
                setLoaded(true);
            } catch (error) {
                console.error("Error fetching template settings or field ordering:", error);
            }
        };

        fetchData();
    }, [clientEventInfo]);

    useEffect(() => {
        if (formData.printChoice && formData.printChoice !== undefined) {
            const fetchRegs = async () => {
                setShowBusy(true);
                // set the registrants for non-conditional selections
                switch (formData.printChoice) {
                    case 'EntireEvent':
                    case 'Entire Event':
                        const allItemsString = await kioskService.getAttendeesWithGuestsSearchPaged(await createFullReturnSearchBody(''));
                        if (allItemsString && allItemsString.length > 0) {
                            const allItems = JSON.parse(allItemsString)
                            setRegistrants(allItems)
                        }
                        break;
                    case 'PrintFranky':
                    case 'Print Franky':
                        const frankyItemString = await kioskService.getFrankyWithGuest(await createFullReturnSearchBody());
                        let holder = []
                        if (frankyItemString && frankyItemString.length > 0) {
                            const frankyItem = JSON.parse(frankyItemString)
                            holder.push(frankyItem)
                        }
                        setRegistrants(holder)
                        break;
                    case 'PrintMissingBadges':
                    case 'Print Missing Badges':
                        const printMissingItemsString = await kioskService.getAttendeesWithGuestsNotPrintedSearchPaged(await createFullReturnSearchBody(''));
                        if (printMissingItemsString && printMissingItemsString.length > 0) {
                            const printMissingItems = JSON.parse(printMissingItemsString)
                            setRegistrants(printMissingItems)
                        }
                        break;
                    default:
                        let defaultTemp = [
                            selectedOption
                        ]
                        setRegistrants(defaultTemp)
                        break;
                }
                setShowBusy(false);
            }
            fetchRegs()
        }
    }, [formData.printChoice])

    useEffect(() => {
        // set defaults
        if (loaded ) {
            setDefaults();
        }

    }, [loaded])

    useEffect(() => {
        // set defaults
        if (templateString !== undefined  && adminPrintChoicesList?.length) {
            setLoaded(true);
        }

    }, [adminPrintChoicesList && templateString])

    // --- REST --- //
    const createRequestBody = async () => {

        let requestBody = {}

        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }

        return await requestBody;
    }
    const createSearchBody = async (searchQuery) => {
        let requestBody = {}
        if (clientEventInfo && clientEventInfo.clientId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`,
                "searchValue": `${searchQuery}`,
                "index": `${currentPage}`,
                "pageSize": `${itemsPerPage}`,
            }
        }

        return await requestBody;
    }

    const createFullReturnSearchBody = async (searchQuery) => {
        let requestBody = {}
        if (clientEventInfo && clientEventInfo.clientId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`,
                "searchValue": `${searchQuery}`,
                "fieldSearch": `${formData.printChoice}`
                //"index": `${currentPage}`,
                //"pageSize": `${itemsPerPage}`,
            }
        }

        return await requestBody;
    }
    const createSingleSearchBody = async (searchQuery) => {
        let requestBody = {}
        if (clientEventInfo && clientEventInfo.clientId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`,
                "searchValue": `${searchQuery}`,
            }
        }

        return await requestBody;
    }
    const createSingleReloadBody = async (searchQuery) => {
        let requestBody = {}
        if (clientEventInfo && clientEventInfo.clientId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`,
                "registrantValue": `${searchQuery}`,
            }
        }

        return await requestBody;
    }

    const handleChange = (e) => {
        if (e.target.type === 'checkbox') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
            formData.recordPrint = !formData.recordPrint
        }
        else if (e.target.type === 'select-one') {
            let filteringOptionSelectedIndex = adminPrintChoicesList.filter(pcl => pcl.name === e.target.value || pcl.text === e.target.value)[0]
            setFormData({
                ...formData,
                [e.target.name]: filteringOptionSelectedIndex.text,
            })
            // clear registrants
            setRegistrants({})
            // clear pages
            setCurrentPage(1)
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
    const setDefaults = async (e) => {
        // set default values
        let filteringOptionSelectedIndex = adminPrintChoicesList.filter(pcl => pcl.name === 'RegistrantSearch' || pcl.text === 'RegistrantSearch')[0]
        setFormData({
            ...formData,
            printChoice: filteringOptionSelectedIndex.text,
        })
        setSearchQuery("");
        // clear registrants
        setRegistrants({})
        // clear pages
        setCurrentPage(1)
    }

    const onBlur =async (e) => {
        // trigger registrant loading for paidafterdate
        const paidAfterDateItems = await kioskService.getAttendeesPaidAfterSearchPaged(await createFullReturnSearchBody(formData.paidAfterDate));
        if (paidAfterDateItems && paidAfterDateItems.length > 0) {
            setRegistrants(paidAfterDateItems)
        }
    }
    const handleTrigger = async (e) => {
        // trigger registrant reload 
        var result = await eventManagementService.reloadIndividualById(await createSingleReloadBody(formData.newRegistration));
        if (result !== null) {
            const singleItem = await kioskService.getAttendeesWithGuestsSearchPaged(await createFullReturnSearchBody(formData.newRegistration));
            if (singleItem && singleItem.length > 0) {
                singleItem.clientId = clientEventInfo.clientId;
                singleItem.eventId = clientEventInfo.eventId;
                singleItem.clientName = clientEventInfo.clientName;
                setSelectedOption(singleItem);
                setRegistrants(singleItem);
                setRegError(null)
            }
        }
        else {
            setRegError(formData.newRegistration + ' load failed!')
        }
    }
    const isFormInvalid = () => {
        return (templateString && adminPrintChoicesList && registrants?.length >0)
    }
    const handlePreview = async e => {
        e.preventDefault()
        GeneratePreview()
    }
    const GeneratePreview = () => {
        if (templateString !== undefined && registrants !== undefined && registrants.length > 0) {
            let jsonObject = JSON.stringify(registrants);
            if (jsonObject && jsonObject !== '[]') {
                let newHTML = JSON.parse(templateString).replace("\"%ATTENDEEINFO%\"", JSON.stringify(jsonObject));
                //console.log(newHTML);
                setHTMLString(newHTML);
            }
           
        }
    }
    const loadOptions = async (searchQuery) => {
        switch (formData.printChoice) {
            case 'RegistrantSearch':
            case 'Registrant Search':
                // returns list of AttendeeBadge (small)
                const registrantSearchItemsString = await kioskService.getSmallAttendeesWithGuestsSearchPaged(await createSearchBody(searchQuery));
                if (!registrantSearchItemsString) {
                    setCurrentPage(1)
                    return {
                        options: [],
                        hasMore: false,
                    };
                }
                const registrantSearchItems = JSON.parse(registrantSearchItemsString)
                registrantSearchItems.forEach((item) => {
                    // has to have value and label defined
                    item.value = item.LocalRegistrationId;
                    item.label = item.FirstName + ' ' + item.LastName + (item.Organization ? ' (' + item.Organization + ')' : '');
                })
                
                setSearchQuery(searchQuery)
                setCurrentPage(currentPage + 1)
                return {
                    options: registrantSearchItems,
                    hasMore: registrantSearchItems.length >= 1,
                    //additional: {
                    //    page: searchQuery ? 2 : page + 1,
                    //},
                };
            case 'RegistrationId':
            case 'Registration Id':
                // returns list of strings
                const registrationIdItems = await kioskService.getAttendeeIdsSearchPaged(await createSearchBody(searchQuery));
                if (!registrationIdItems) {
                    setCurrentPage(1)
                    return {
                        options: [],
                        hasMore: false,
                    };
                }
                let registrationIdObjArray = []
                registrationIdItems.forEach((item) => {
                    let registrationIdtemp = {} 
                    // has to have value and label defined
                    registrationIdtemp.value = item;
                    registrationIdtemp.label = item;
                    registrationIdObjArray.push(registrationIdtemp)
                })
                setSearchQuery(searchQuery)
                setCurrentPage(currentPage + 1)
                return {
                    options: registrationIdObjArray,
                    hasMore: registrationIdObjArray.length >= 1,
                    //additional: {
                    //    page: searchQuery ? 2 : page + 1,
                    //},
                };
            case 'RegistrationType':
            case 'Registration Type':
                // returns list of strings
                const registrationTypeItems = await kioskService.getAttendeeRegistrationTypesSearchPaged(await createSearchBody(searchQuery));
                if (!registrationTypeItems) {
                    setCurrentPage(1)
                    return {
                        options: [],
                        hasMore: false,
                    };
                }
                let registrationTypeObjArray = []
                registrationTypeItems.forEach((item) => {
                    let registrationTypetemp = {}
                    // has to have value and label defined
                    registrationTypetemp.value = item;
                    registrationTypetemp.label = item;
                    registrationTypeObjArray.push(registrationTypetemp)
                })
                setSearchQuery(searchQuery)
                setCurrentPage(currentPage + 1)
                return {
                    options: registrationTypeObjArray,
                    hasMore: registrationTypeObjArray.length >= 1,
                    //additional: {
                    //    page: searchQuery ? 2 : page + 1,
                    //},
                };
            case 'Organization':
                // returns list of strings
                const organizationItems = await kioskService.getAttendeeOrganizationsSearchPaged(await createSearchBody(searchQuery));
                if (!organizationItems) {
                    setCurrentPage(1)
                    return {
                        options: [],
                        hasMore: false,
                    };
                }
                let organizationObjArray = []
                organizationItems.forEach((item) => {
                    let organizationtemp = {}
                    // has to have value and label defined
                    organizationtemp.value = item;
                    organizationtemp.label = item;
                    organizationObjArray.push(organizationtemp)
                })
                setSearchQuery(searchQuery)
                setCurrentPage(currentPage + 1)
                return {
                    options: organizationObjArray,
                    hasMore: organizationObjArray.length >= 1,
                    //additional: {
                    //    page: searchQuery ? 2 : page + 1,
                    //},
                };
            default:
                const defaultItems = await kioskService.getSmallAttendeesWithGuestsSearchPaged(await createSearchBody(searchQuery));
                if (!defaultItems) {
                    setCurrentPage(1)
                    return {
                        options: [],
                        hasMore: false,
                    };
                }
                defaultItems.forEach((item) => {
                    // has to have value and label defined
                    item.value = item.LocalRegistrationId;
                    item.label = item.FirstName + ' ' + item.LastName + (item.Organization ? ' (' + item.Organization + ')' : '');
                })
                setSearchQuery(searchQuery)
                setCurrentPage(currentPage + 1)
                return {
                    options: defaultItems,
                    hasMore: defaultItems.length >= 1,
                    //additional: {
                    //    page: searchQuery ? 2 : page + 1,
                    //},
                };
        }
    };
    // Print   opens the full badge HTML document in a new window and prints it.
    // react-to-print cannot print an iframe's srcDoc content (it clones the
    // outer iframe DOM node, not the document inside it). Using window.open()
    // is the correct approach when the print target is a complete HTML string.
    const handlePrint = () => {
        if (!htmlString) return
        const printWindow = window.open('', '_blank')
        printWindow.document.open()
        printWindow.document.write(htmlString)
        printWindow.document.close()
        // Allow the badge template's window.onload script to run and
        // populate the badges-container before triggering the print dialog.
        setTimeout(() => {
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        }, 500);
        if (formData.recordPrint && formData.recordPrint === true && formData.printChoice !== "PrintFranky") {
            let registrantsHolder = [];
            registrants.forEach((registrant) => {
                // update each record for storage
                const registrantHolder = JSON.parse(registrant);
                registrantHolder.ClientName = clientEventInfo.clientName;
                registrantsHolder.push(registrantHolder);
            })
            let printedRegistrants = {
                clientId: clientEventInfo.clientId,
                eventId: clientEventInfo.eventId,
                printedRecords: registrantsHolder
            }
            kioskService.recordAttendeesPrint(printedRegistrants);
        }
        // clear form 
        //clearFormData()
        //setDefaults();
    }

    const onChange = option => {
        if (option) {
            option.clientId = clientEventInfo.clientId;
            option.eventId = clientEventInfo.eventId;
            option.clientName = clientEventInfo.clientName;
        }
        
        // triggered when option selected
        // navigate to edit screen? or need to press continue to move forward
        // have to get all entries for the option
        setSelectedOption(option)
    };

    const onInputChange = entry => {
        // triggered when typing changes
        if (entry !== searchQuery) {
            // reset pages
            setCurrentPage(1)
            //setSelectedOption({})
        }
    };

    // Component rendering logic based on dropdown selection
    const componentMap = {
        "RegistrantSearch": RegistrantName,
        "Registrant Search": RegistrantName,
        "RegistrationId": RegistrationId,
        "Registration Id": RegistrationId,
        "RegistrationType": RegistrationType,
        "Registration Type": RegistrationType,
        "Organization": Organization,
        "PaidAfterDate": PaidAfterDate,
        "Paid After Date": PaidAfterDate,
        "NewRegistration": NewRegistration,
        "New Registration": NewRegistration,
    };

    const SelectedComponent = componentMap[formData.printChoice];

    return (
        <>
            {loaded ?
                <div id={styles.adminPrintPage}>
                    <h1>Flat Template Admin Print</h1>
                    <h3>Note: Less options than Admin Print due to setup differences!</h3>
                    <h2 id={styles.pageHeader}>{clientEventInfo.clientName} - {clientEventInfo.eventName}</h2>
                        <div className={styles.inputContainer}>
                            <label
                                htmlFor="printChoice"
                                className={styles.label}
                            >
                                Create Badges for:
                            </label>

                            <select
                                name="printChoice"
                                id={styles.selectDropdown}
                                value={formData.printChoice}
                                key={formData.printChoice}
                                onChange={handleChange}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    adminPrintChoicesList.map((adminPrintChoice, idx) => (
                                        <option key={idx} value={adminPrintChoice.value} title={adminPrintChoice.title}>{adminPrintChoice.text}</option>
                                    ))
                                }
                            </select>

                            {SelectedComponent && (
                            <SelectedComponent
                                key={registrants }
                                {...(SelectedComponent === PaidAfterDate || 
                                    SelectedComponent === NewRegistration
                                    ? { formData, handleChange, onBlur, handleTrigger, regError }
                                    : { loadOptions, onChange, onInputChange })}
                                />
                            )}

                            <div id={styles.recordPrintSection}>
                                <label
                                    htmlFor="recordPrint"
                                    className={styles.label}
                                >
                                    Record print: 
                                </label>
                                <input
                                    type="checkbox"
                                    value={formData.recordPrint}
                                    checked={formData.recordPrint}
                                    name="recordPrint"
                                    onChange={handleChange}
                                />
                                <HoverButton
                                    title={'Record the print to printed badges table.'}
                                    messageWidth={350}
                                />
                        </div>
                        <div className={styles.containerSmaller}>
                            <button disabled={!isFormInvalid()} onClick={handlePreview} className={styles.leftButton}>
                                Preview
                            </button>
                            <button disabled={!isFormInvalid()} className={styles.rightButton} onClick={handlePrint}>
                                Print
                            </button>
                        </div>
                        {templateString && templateString !== undefined && htmlString && htmlString.length > 0 && registrants && registrants.length > 0 ?
                                <div id={styles.printBadgeSection}>
                                
                                        <div className={styles.centerPrint}>
                                    <iframe srcDoc={htmlString} title="Badge Content Preview" id='iframeBadge'
                                                sandbox="allow-scripts allow-modals"
                                                style={{ width: '100%', height: '500px', border: '1px solid #ccc' }}
                                            />
                                        </div>

                                    {formData.printChoice && formData.printChoice.toLowerCase() === "entire event" ?
                                        <button className={styles.adminPrintForm} id={styles.printButton} onClick={handlePrint}>
                                            Print
                                        </button>
                                        :
                                        <></>
                                    }                                    
                                </div>
                            :
                            showBusy ?
                                <div id={styles.loadingContainer}>
                                    <LoadingSpinner />
                                </div> :
                                <></>
                            }
                        </div>
                </div>
            :
                <LoadingSpinner />
        }
        </>
    );
}

export default AdminPrintFlat;
